import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m7.75,11c-.192,0-.384-.073-.53-.22L2.97,6.53c-.293-.293-.293-.768,0-1.061L7.22,1.22c.293-.293.768-.293,1.061,0s.293.768,0,1.061l-3.72,3.72,3.72,3.72c.293.293.293.768,0,1.061-.146.146-.338.22-.53.22Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconChevronLeftFill12.js.map